<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-add-tab-info">

    <div class="mt-5">
      <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit"
        @on-complete="formSubmitted">
        <tab-content :title="$t('MODULES.basic_data')" class="mb-5" icon="feather icon-home"
          :before-change="validateStep1">

          <!-- tab 1 content -->
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-5">
              <label class="vs-input--label">{{ $t('MODULES.moduleType') }}</label>
              <v-select v-model="moduleType" :options="moduleTypes" label="name" disabled />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input :label="$t('MODULES.name')" v-model="name" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5">
              <vs-input :label="$t('MODULES.prefix')" v-model="prefix" class="w-full" maxLength="3" @input="setPrefix"
                disabled />
            </div>
            <div class="vx-col md:w-1/4 w-full" v-show="moduleType.name !== 'Único registro'">
              <div class="mt-4">
                <label class="vs-input--label">{{ $t('MODULES.usersCanAssignRecordsTo') }}</label>
                <v-select v-model="canAssignValue" label="label" :clearable="false" :options="canAssignOptions"
                  name="can_view" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/4 w-full" v-show="moduleType.name !== 'Único registro'">
              <div class="mt-4">
                <label class="vs-input--label">{{ $t('MODULES.usersCanViewRecordsOf') }}</label>
                <v-select v-model="canViewValue" :clearable="false" :options="canViewOptions" name="can_assign"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showColumnsOnForm">
              <label class="vs-input--label">{{ $t('MODULES.columnsInForm') }}</label>
              <v-select v-model="columnsOnForm" :options="columnsOnFormOptions" label="name" />
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showLinesPerPage">
              <label class="vs-input--label">{{ $t('MODULES.rowsPerPage') }}</label>
              <v-select v-model="linesByPage" :options="linesByPageOptions" label="name" />
            </div>
            <div class="vx-col md:w-1/3 w-full mt-5" v-show="showIcons">
              <label class="vs-input--label">{{ $t('MODULES.icon') }}</label>
              <v-select class="icon-select" v-model="icon" :options="iconOptions" label="name">
                <template v-slot:option="option">
                  <feather-icon :icon="option.value" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" /> {{
        option.name }}
                </template>
              </v-select>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showLinesPerPage">
              <label class="vs-input--label">{{ $t('MODULES.identifierField') }}</label>
              <v-select v-model="moduleField" :options="moduleFields" label="name" />
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5">
              <label class="vs-input--label">{{ $t('MODULES.requiresAuthentication') }}</label>
              <ul class="con-s w-full mb-2">
                <li>
                  <vs-switch v-model="requireAuthentication" class="mt-2" />
                </li>
              </ul>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-5" v-show="showColorCustomizer">
              <label class="vs-input--label">{{ $t('MODULES.calendarEventColor') }}</label>
              <ul>
                <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2"
                    v-model="customPrimaryColor" type="color" /></li>
              </ul>
            </div>
            <div class="vx-col md:w-1/1 w-full" style="margin-top: -10px!important;">
              <vs-textarea v-model="description" :label="$t('MODULES.description')" class="mb-0 md:mt-10 mt-6"
                rows="3" />
            </div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content :title="$t('MODULES.appearance')" class="mb-5" icon="feather icon-camera" v-if="showAppearanceTab">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="tableStripped" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.striped_table')}`" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="manageRows" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.manageDisplayedRows')}`" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="searchField" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.searchFieldInTable')}`" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="additionalInformation" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.additionalInformation')}`" />
              </vx-input-group>
            </div>
          </div>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content :title="$t('MODULES.exportation')" class="mb-5" icon="feather icon-download" v-if="showExportTab"
          :before-change="validateStep3">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportPdf" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.exportTableToPDF')}`" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportExcel" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.exportTableToExcel')}`" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="exportCsv" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.exportTableToCSV')}`" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="copyTableData" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.copyTableData')}`" />
              </vx-input-group>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <label for="" class="vs-input--label"></label>
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="print" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.print')}`" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full" v-if="print">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <vs-input v-model="printButtonLabel" :label="$t('MODULES.buttonLabel')" />
              </vx-input-group>
            </div>
            <div class="vx-col" v-if="print">
              <label for="" class="vs-input--label">{{ $t('MODULES.maximumTimeout') }}</label>
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <vs-input-number v-model="maxPrintTimeout" :min="10" />
              </vx-input-group>
            </div>
          </div>
        </tab-content>

        <!-- tab 4 content -->
        <tab-content :title="$t('MODULES.list')" class="mb-5" icon="feather icon-list" v-if="showListTab">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="addList" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.minimizedLists')" />
              </vx-input-group>

            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="collapsedLists" />
                  </div>
                </template>

                <vs-input :value="$t('MODULES.addLists')" />
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
                <template slot="prepend">
                  <div class="prepend-text">
                    <vs-switch v-model="showList" />
                  </div>
                </template>

                <vs-input :value="`${$t('MODULES.displayLists')}`" />
              </vx-input-group>

            </div>
          </div>
        </tab-content>
      </form-wizard>
      <br><br>
    </div>
  </div>


</template>

<script>
import vSelect from 'vue-select'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { setApplicationLocalStorageItem, performFetch } from '../../../helpers'

export default {
  components: {
    vSelect,
    FormWizard,
    TabContent
  },
  data() {
    return {
      moduleFields: [],
      moduleField: {},
      showIcons: false,
      showColorCustomizer: false,
      customPrimaryColor: '#3DC9B3',
      showAppearanceTab: true,
      showExportTab: true,
      showListTab: true,
      name: '',
      prefix: '',
      icon: null,
      iconOptions: [],
      moduleType: null,
      moduleTypes: [],
      columnsOnForm: 1,
      columnsOnFormOptions: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
      ],
      linesByPage: 10,
      linesByPageOptions: [
        10,
        15,
        20,
        50
      ],
      showColumnsOnForm: true,
      showCanAssignAndCanView: true,
      showLinesPerPage: true,
      requireAuthentication: true,
      description: '',
      city: 'new-york',
      proposalTitle: '',
      jobTitle: '',
      textarea: '',
      eventName: '',
      eventLocation: 'san-francisco',
      status: 'plannning',
      tableStripped: true,
      manageRows: true,
      searchField: true,
      additionalInformation: true,
      exportPdf: true,
      exportExcel: true,
      exportCsv: true,
      copyTableData: true,
      canAssignValue: {},
      canViewValue: {},
      canAssignOptions: [
        { label: this.$t('MODULES.canAssignValue'), value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'), value: 2 },
        { label: 'Apenas cargo subordinado', value: 3 }
      ],
      canViewOptions: [
        { label: this.$t('MODULES.canAssignValue'), value: 1 },
        { label: this.$t('MODULES.sameOrSubordinateRole'), value: 2 },
        { label: this.$t('MODULES.userGroup'), value: 3 },
        { label: this.$t('MODULES.userGroupAndSameOrSubordinateRole'), value: 4 },
        { label: this.$t('MODULES.onlyYourUser'), value: 5 }
      ],
      print: false,
      printButtonLabel: '',
      maxPrintTimeout: 10,
      addList: true,
      collapsedLists: true,
      showList: true,
      menu: 1,
      menuOptions: [
        { text: this.$t('MODULES.journalism'), value: 1 },
        { text: this.$t('MODULES.apps'), value: 2 }
      ],
      cityOptions: [
        { text: this.$t('MODULES.newYork'), value: 'new-york' },
        { text: this.$t('MODULES.chicago'), value: 'chicago' },
        { text: this.$t('MODULES.sanFrancisco'), value: 'san-francisco' },
        { text: this.$t('MODULES.boston'), value: 'boston' }
      ],
      statusOptions: [
        { text: this.$t('MODULES.planning'), value: 'planning' },
        { text: this.$t('MODULES.inProgress'), value: 'in progress' },
        { text: this.$t('MODULES.finished'), value: 'finished' }
      ],
      LocationOptions: [
        { text: this.$t('MODULES.newYork'), value: 'new-york' },
        { text: this.$t('MODULES.chicago'), value: 'chicago' },
        { text: this.$t('MODULES.sanFrancisco'), value: 'san-francisco' },
        { text: this.$t('MODULES.boston'), value: 'boston' }
      ]
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
    // selectedRole: {
    //   set(obj) {
    //     this.selectedRole = obj
    //   },
    //   get() {
    //     this.selectedRole = obj
    //   }
    // }
  },
  async created() {
    this.$vs.loading({ type: 'default' })
    await this.viewParameters()
    this.$vs.loading.close()
  },
  methods: {
    setCalendarModuleForm() {
      this.showAppearanceTab = false
      this.showExportTab = false
      this.showListTab = false
      this.showColumnsOnForm = false
      this.showLinesPerPage = false
      this.showIcons = false
      this.showColorCustomizer = true
      this.showCanAssignAndCanView = true
    },
    unsetCalendarModuleForm() {
      this.showAppearanceTab = true
      this.showExportTab = true
      this.showListTab = true
      this.showColumnsOnForm = true
      this.showLinesPerPage = true
      this.showIcons = true
      this.showColorCustomizer = false
      this.showCanAssignAndCanView = true
    },
    validateStep1() {

      if (this.name === '' || !this.name) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.prefix === '' || !this.prefix) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: 'O campo Prefixo é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.prefix.length < 3) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.prefixFieldCharacters'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.columnsOnForm === '' || !this.columnsOnForm) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.columns_in_form') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.moduleType === '' || !this.moduleType) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.type') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.linesByPage === '' || !this.linesByPage) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.rowsPerPage') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.icon === '' || !this.icon) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.icon') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      return true
    },
    validateStep3() {

      if (this.print && (this.printButtonLabel === '' || this.printButtonLabel === null)) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.label') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      if (this.print && (this.maxPrintTimeout === '' || this.maxPrintTimeout === null)) {

        this.$vs.notify({
          title: this.$t('MODULES.Attention'),
          text: this.$t('MODULES.fieldIsRequired', { field: this.$t('MODULES.maximumTimeout') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false

      }

      return true

    },
    setPrefix(val) {
      this.prefix = val.toUpperCase()
    },
    async viewParameters() {
      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_add_application_module_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (responseData) => {

              this.iconOptions = responseData.parameters.icons
              this.moduleTypes = responseData.parameters.module_types

              await performFetch(this.$store.state.auth.api_url, {
                command: 'module_management_get_application_module_detail',
                parameters: {
                  application_token: this.$store.state.auth.app_token,
                  session_token: this.$store.state.auth.token,
                  module_hash: this.$route.params.moduleHash
                }
              })
                .then(async (response) => {
                  if (response.status === 200) {
                    await response.json().then(async (responseData) => {

                      this.name = responseData.module.name
                      this.description = responseData.module.description
                      this.icon = { hash: responseData.module.icon_hash, name: responseData.module.icon_name, value: responseData.module.icon_value }
                      this.prefix = responseData.module.prefix
                      this.requireAuthentication = responseData.module.require_authentication
                      this.moduleType = { hash: responseData.module.type_hash, name: responseData.module.type_name }
                      this.columnsOnForm = responseData.module.columns_on_form
                      this.linesByPage = responseData.module.lines_per_page
                      this.customPrimaryColor = responseData.module.color
                      this.print = responseData.module.enable_print
                      this.printButtonLabel = responseData.module.print_button_label
                      this.maxPrintTimeout = responseData.module.max_print_timeout
                      this.canAssignValue = this.canAssignOptions.find(x => x.value === responseData.module.can_assign_type_id)
                      this.canViewValue = this.canViewOptions.find(x => x.value === responseData.module.can_view_type_id)
                      this.moduleFields = responseData.module.fields

                      if (responseData.identifier_field !== null) {
                        this.moduleField = responseData.module.fields.find(x => x.hash === responseData.module.identifier_field)
                      }


                      if (responseData.module.type_name === 'Calendar') {
                        this.setCalendarModuleForm()
                      }

                    })
                  } else if (response.status == 401) {
                    this.$vs.loading.close()
                    setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                    store.dispatch('auth/signOut')
                  } else {
                    this.$vs.notify({
                      title: this.$t('MODULES.attention'),
                      text: this.$t('MODULES.errorCapturingModuleDetails'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                  }

                  this.$vs.loading.close()
                })
                .catch((error) => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: this.$t('MODULES.operation_not_completed'),
                    text: this.$t('MODULES.errorRegisteringUser'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })

            })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.notify({
              title: this.$t('MODULES.operation_not_completed'),
              text: this.$t('MODULES.errorRegisteringUser'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }

          this.$vs.loading.close()
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.operation_not_completed'),
            text: this.$t('MODULES.errorRegisteringUser'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },


    async formSubmitted() {

      this.$vs.loading({
        type: 'default'
      })

      const payloadData = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module: {
          hash: this.$route.params.moduleHash,
          name: this.name,
          columns_on_form: this.columnsOnForm,
          icon_hash: this.icon.hash,
          require_authentication: this.requireAuthentication,
          description: this.description,
          lines_per_page: this.linesByPage,
          color: this.moduleType.hasOwnProperty('name') && this.moduleType.name === 'Calendar' ? this.customPrimaryColor : null,
          enable_print: this.print,
          print_button_label: this.printButtonLabel,
          max_print_timeout: this.maxPrintTimeout,
          can_assign_type_id: this.canAssignValue.value,
          can_view_type_id: this.canViewValue.value,
          identifier_field: this.moduleField && Object.keys(this.moduleField).length > 0 ? this.moduleField.hash : null
        }
      }

      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_update_application_module',
        parameters: payloadData
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('MODULES.operationCompletedTitle'),
                text: this.$t('MODULES.moduleUpdatedSuccessfully'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

              this.$router.push('/module-management')
            })
          } else if (response.status == 400) {
            await response.json()
              .then(async (response) => {
                this.$vs.loading.close()
                if (response.message === 'Module Name Already Exists') {
                  this.$vs.notify({
                    title: this.$t('MODULES.Attetion'),
                    text: this.$t('MODULES.moduleAlreadyExists'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                  })


                }
              })
          } else if (response.status == 401) {
            this.$vs.loading.close()
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('MODULES.FailedOperation'),
              text: this.$t('MODULES.errorUpdatingModule'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MNODULES.FailedOperation'),
            text: this.$t('MODULES.errorRegisteringModule'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
<style>
.icon-select .vs__dropdown-menu {

  height: 150px !important;
}
</style>
